import React from 'react'

interface Props {
  htmlContent: string
}

const HtmlRenderer: React.FC<Props> = ({ htmlContent }) => {
  return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
}

export default HtmlRenderer
